import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { Button, ButtonGroup, Col, Row } from "react-bootstrap";
import { createReportScheme, deleteReportScheme, getAllReportItems, updateReportScheme } from "../Store/Thunk";
import { setRole, updateReportSchemeState } from "../Store";
import BreadCrumb from "../../../BreadCrumb";
import BasicGraphSummaryEntity from "./Entities/BasicGraphSummaryEntity";
import BasicGraphDetailEntity from "./Entities/BasicGraphDetailEntity";
import MonoTextuaryEntity from "./Entities/MonoTextuaryEntity";
import DualTextuaryEntity from "./Entities/DualTextuaryEntity";
import Overlay from "../../../../SharedComponents/Overlay";
import SchemeElementModal from "./SchemeElementModal";
import EmptySpace from "./HtmlElements/EmptySpace";
import MonoSpace from "./HtmlElements/MonoSpace";
import DualSpace from "./HtmlElements/DualSpace";
import ImageSpace from "./HtmlElements/ImageSpace";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import HeightCalculator from "./HeightCalculator";
import Dropdown from "react-bootstrap/Dropdown";
import EntityInfoModal from "./Entities/EntityInfoModal/EntityInfoModal";
import TestScaleEntity from "./ApplicationElements/TestScaleEntity";
import AnsweringTendencyEntity from "./ApplicationElements/AnsweringTendencyEntity";
import MassFilterButtonGroup from "./MassFilterButtonGroup";
import { applicationTypeEnum, GetKeyByValue } from "../../../../../Helpers/EnumHelper";

export default function ReportScheme() {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { state } = useLocation();
  const reportSchemeState = useSelector((state) => state.reportScheme);
  const entityModalInfo = useSelector((state) => state.reportScheme.entityModalInfo);
  const role = useSelector((state) => state.reportScheme.role);
  const [schemeElementModalData, setSchemeElementModalData] = useState({
    show: false,
    type: null,
  });

  //yeni eklenecek dropdown ile hedef array secilecek

  const components = {
    BasicGraphSummaryEntity,
    BasicGraphDetailEntity,
    MonoTextuaryEntity,
    DualTextuaryEntity,
    DualSpace,
    MonoSpace,
    EmptySpace,
    ImageSpace,
    TestScaleEntity,
    AnsweringTendencyEntity,
  };

  useEffect(() => {
    dispatch(updateReportSchemeState({ testId: state.id })); //todo: is testId right for this ?
    dispatch(getAllReportItems({ id: state.id, applicationType: state.applicationType }));
  }, [role]);

  useEffect(() => {
    return () => {
      dispatch(setRole({ role: "Admin" }));
    };
  }, []);

  const Paginate = (scheme) => {
    let Page = [];
    let Pages = [];
    let maxPageHeight = 1020; //A4 page size 1120px height
    let currentPageHeight = 0;

    scheme.forEach((reportItem, index) => {
      //if under maxPageHeight   push into Page[]
      if (currentPageHeight + parseInt(Number(reportItem.height), 10) < maxPageHeight) {
        Page.push(reportItem);
        currentPageHeight = currentPageHeight + parseInt(Number(reportItem.height), 10);
        if (index === scheme.length - 1) {
          //if the Page is not filled, and it's the end of the scheme; bundle & push anyway.
          currentPageHeight = 0;
          Pages.push(Page);
          Page = [];
        }
      }
      // bundle the Page array and push it into Pages[]
      else {
        currentPageHeight = 0;
        Pages.push(Page);
        Page = [];

        Page.push(reportItem);

        if (index === scheme.length - 1) {
          Pages.push(Page); //if last item
        }
        currentPageHeight = currentPageHeight + parseInt(Number(reportItem.height), 10);
      }
    });
    return Pages;
  };

  const UpsertScheme = () => {
    var postObj = {
      applicationId: reportSchemeState.inventory.id,
      applicationType: state.applicationType,
      role: role,
      WrapUpJson: JSON.stringify(reportSchemeState.visibleReportItemEntityList),
      PdfJson: JSON.stringify(Paginate(reportSchemeState.visibleReportItemEntityList)),
    };
    console.log(reportSchemeState.visibleReportItemEntityList);
    console.log(Paginate(reportSchemeState.visibleReportItemEntityList));
    //TODO: check here for html element presence, frontend problems.

    if (reportSchemeState?.inventory?.reportScheme) {
      postObj.id = reportSchemeState.inventory.reportScheme.id;
      dispatch(updateReportScheme(postObj));
    } else {
      dispatch(createReportScheme(postObj));
    }
  };

  const DeleteReportScheme = () => {
    dispatch(deleteReportScheme({ id: reportSchemeState?.inventory?.reportScheme.id }));
  };

  const CreateDynamicComponent = (entity, i) => {
    const SpecificComponent = components[entity.componentName];

    return (
      <SpecificComponent key={i} entity={entity}>
        {!Boolean(entity?.height) && (
          <div style={{ position: "absolute", left: "-999999px" }}>
            <HeightCalculator
              entity={entity}
              type={GetKeyByValue(state.applicationType, applicationTypeEnum).toLowerCase()}
            />
          </div>
        )}
      </SpecificComponent>
    );
  };

  const CreateDynamicComponentWithOutHeightCalculation = (entity, i) => {
    const SpecificComponent = components[entity.componentName];

    return <SpecificComponent key={i} entity={entity} />;
  };

  return (
    <div>
      {reportSchemeState.isLoading && <Overlay />}
      <BreadCrumb
        pageName={t("Şema")}
        backPageName={state.isTest ? t("tests") : t("inventories")}
        backUrl={state.isTest ? "/test" : "/inventory"}
      >
        <Row className={"justify-content-between"}>
          <Col xs="12" md="5">
            <Row xs="auto">
              <Col xs={"auto"}>
                <h3> {reportSchemeState?.inventory?.id} </h3>
              </Col>
              <Col xs={"auto"}>
                <h3> {reportSchemeState?.inventory?.name} </h3>
              </Col>
            </Row>
          </Col>
          <Col xs="12" md="auto">
            <Dropdown drop={"down-centered"}>
              <Dropdown.Toggle size={"sm"}>{role.charAt(0).toUpperCase() + role.slice(1)}</Dropdown.Toggle>{" "}
              {/*upper case method*/}
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    dispatch(setRole({ role: "Admin" }));
                  }}
                >
                  Admin
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    dispatch(setRole({ role: "User" }));
                  }}
                >
                  User
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col xs="12" md="auto">
            <ButtonGroup>
              <Button size={"sm"} onClick={() => setSchemeElementModalData({ show: true, type: "mono" })}>
                Tek Bölüm
              </Button>
              <Button size={"sm"} onClick={() => setSchemeElementModalData({ show: true, type: "dual" })}>
                Çift Bölüm
              </Button>
              <Button size={"sm"} onClick={() => setSchemeElementModalData({ show: true, type: "space" })}>
                Boşluk
              </Button>
              <Button size={"sm"} onClick={() => setSchemeElementModalData({ show: true, type: "image" })}>
                Görsel
              </Button>
            </ButtonGroup>
          </Col>
          <Col xs="12" md="auto">
            <Row xs="auto" className="justify-content-md-end">
              <Col>
                <Button size={"sm"} onClick={() => UpsertScheme()}>
                  {reportSchemeState?.inventory?.reportScheme ? "Güncelle" : "Kaydet"}
                </Button>
              </Col>
              {reportSchemeState?.inventory?.reportScheme && (
                <Col>
                  <Button size={"sm"} variant="danger" onClick={DeleteReportScheme}>
                    Kaydı Sil
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </BreadCrumb>

      <Row>
        <Col>
          <h1 className={"mb-0"}> Rapor Elemanları </h1>
        </Col>
        <Col xs={"auto"}>
          <MassFilterButtonGroup />
        </Col>
      </Row>

      <ScrollableCard>
        {reportSchemeState.visibleReportItemEntityList && //truelari listele
          reportSchemeState.visibleReportItemEntityList.map((entity, i) => {
            const key = `${i} ${entity.order}`;
            return CreateDynamicComponent(entity, key);
          })}

        <h1> Kaldırılanlar </h1>
        {reportSchemeState.nonVisibleReportItemEntityList && //falseları listele
          reportSchemeState.nonVisibleReportItemEntityList.map((entity, i) => {
            const key = `${i} ${entity.order}`;
            return (
              <div className={"opacity-50"} key={i}>
                {CreateDynamicComponentWithOutHeightCalculation(entity, key)}
              </div>
            );
          })}
      </ScrollableCard>

      <SchemeElementModal
        schemeElementModalData={schemeElementModalData}
        onHide={() => setSchemeElementModalData({ show: false, type: null })}
      />
      {entityModalInfo.isShown && (
        <EntityInfoModal isShown={entityModalInfo.isShown} entity={entityModalInfo.entity}></EntityInfoModal>
      )}
    </div>
  );
}
